import { useState } from "react"
import { useTranslation } from "react-i18next"
import Loading from "components/commons/Loading"
import { useSendWhistleMutation } from "../api/whistleApiSlice"

function NewWhistleModal({
    onSuccess = () => { }
}) {

    const [t, i18n] = useTranslation(["global", "whistle"])

    const [anonymousWhistle, setAnonymousWhistle] = useState(true)

    const [
        sendRequest, {
            data: sendingResult,
            isLoading: sendingIsLoading,
            isSuccess: sendingIsSuccess,
            reset: resetSending
        }
    ] = useSendWhistleMutation()

    const handleSubmit = async (e) => {
        e.preventDefault()
        const payload = {
            title: e.target.title.value,
            content: e.target.body.value,
            isUrgent: e.target.urgent.checked,
            isAnonymous: anonymousWhistle,
        }
        sendRequest(payload)
    }

    return (
        <>
            <button type="button w-100" className="btn btn-primary " data-bs-toggle="modal" data-bs-target="#newWhistleModal" onClick={() => { resetSending() }}>
                <a className="nav-link"> <i className="fa-solid fa-circle-plus"></i> {t("whistle:helper.new_signed_warning_title")}</a>
            </button>

            <div className="modal fade" id="newWhistleModal" aria-hidden="true" aria-labelledby="exampleModalToggleLabel" tabIndex="-1">
                <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content  bg-dark text-white">
                        <div className="modal-header">
                            <h5 className="modal-title" id="exampleModalToggleLabel"><i className="fa-solid fa-circle-exclamation"></i> {t("whistle:helper.new_signed_warning_title")}</h5>
                            <button type="button" className="btn-close bg-light" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                        <div className="modal-body">
                            <div className="row">
                                <p>{t("whistle:helper.new_warning_type_select")}</p>
                                <div className="btn-group">
                                    <button type="button" onClick={() => { setAnonymousWhistle(false) }} data-bs-toggle="modal" data-bs-target="#newWhistleModalForm" className="btn btn-secondary p-4"><h6> <i className="fa-solid fa-user-tag"></i> {t("whistle:entity.warning.type.signed")}</h6></button>
                                    <button type="button" onClick={() => { setAnonymousWhistle(true) }} data-bs-toggle="modal" data-bs-target="#newWhistleModalForm" className="btn btn-dark p-4"><h6><i className="fa-solid fa-masks-theater"></i> {t("whistle:entity.warning.type.anonymous")}</h6></button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="modal fade" id="newWhistleModalForm" aria-hidden="true" aria-labelledby="newWhistleModalForm" tabIndex="-1">
                <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content  bg-dark text-white">
                        {
                            sendingIsSuccess == false &&
                            <div className="modal-header">
                                <h5 className="modal-title" id="exampleModalToggleLabel2"><i className="fa-solid fa-circle-exclamation"></i> {anonymousWhistle ? t("whistle:helper.new_anonymous_warning_title") : t("whistle:helper.new_signed_warning_title")}</h5>
                                <button type="button" className="btn-close bg-light" data-bs-dismiss="modal" aria-label="Close"></button>
                            </div>
                        }
                        <div className="modal-body">
                            {
                                sendingIsSuccess ?
                                    <>
                                        <h3><i className="fa-solid fa-circle-check text-success"></i> {t("whistle:helper.new_warning_succesfully_sent")}</h3>
                                        {
                                            anonymousWhistle &&
                                            <>
                                                <br />
                                                <p>{t("whistle:helper.code_description")}</p>
                                                <div className="text-center p-2"><span className="badge text-eh bg-black bg-opacity-10 rounded-pill"><h2 className="p-2"><i className="fa-solid fa-key fa-beat text-white"></i> {sendingResult.code}</h2></span></div>
                                                <p className="text-muted small p-1">{t("whistle:helper.code_disclaimer")}</p>
                                            </>
                                        }
                                    </>
                                    :
                                    <>
                                        {
                                            sendingIsLoading == false ?
                                                <>
                                                    <p>{anonymousWhistle ? t("whistle:helper.new_warning_fill_anonymous") : t("whistle:helper.new_warning_fill_signed")}</p>
                                                    <hr />
                                                    <form className="row g-3" onSubmit={handleSubmit}>

                                                        <div className="col-12">
                                                            <div className="form-check">
                                                                <input className="form-check-input" type="checkbox" id="urgent" />
                                                                <label className="form-check-label"htmlFor="gridCheck">
                                                                    {t("whistle:helper.require_urgency")}
                                                                </label>
                                                            </div>
                                                        </div>

                                                        <div className="col-md-6">
                                                            <input type="text" className="form-control" id="title" placeholder={t("whistle:placeholder.object")} />
                                                        </div>

                                                        <div className="col-12">
                                                            <textarea type="text" className="form-control" id="body" placeholder={t("whistle:placeholder.content")} />
                                                        </div>


                                                        <div className="col-12">
                                                            <button type="submit" className="btn btn-primary">{t("action.send")}</button>
                                                        </div>
                                                    </form>
                                                </> : <Loading />
                                        }
                                    </>
                            }
                        </div>
                        {
                            sendingIsSuccess &&
                            <div className="modal-footer">
                                <button className="btn btn-primary" data-bs-target="#newWhistleModalForm" data-bs-toggle="modal">{t("action.close")}</button>
                            </div>
                        }
                    </div>
                </div>
            </div>
        </>
    )
}

export default NewWhistleModal